"use client";
import React, { useState } from "react";

const ComponentInput = ({
  label,
  valueInput,
  onChange,
  placeholder,
  type = "text",
  name,
  typeInput,
  required = false,
  styleInput,
  isRequired = false,
  maxLength,
  minLength,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const length = valueInput?.length || 0;
  return (
    <div className="flex flex-col ">
      {label && (
        <label className="pl-2 mb-2 text-[#422EAE] gap-2 font-bold flex items-start">
          {label}
          {isRequired && <span className="text-[#EE443F]">*</span>}
        </label>
      )}
      <div className=" flex flex-col gap-2 ">
        {typeInput === "textarea" ? (
          <textarea
            maxLength={maxLength}
            minLength={minLength}
            className=" placeholder:text-[#D1D1FF] p-4  outline-none rounded-[16px] min-h-[120px]  text-[#35258B]  border  focus:border-[#35258B] border-[#AEB6FB]"
            type={type}
            name={name}
            onFocus={() => setIsFocused(true)}
            onBlur={() => {
              setIsFocused(false);
            }}
            value={valueInput}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
          />
        ) : (
          <input
            className={`${styleInput} placeholder:text-[#D1D1FF] pl-4  outline-none rounded-[16px] h-[56px] text-[#35258B]  border  focus:border-[#5754E5] border-[#AEB6FB]`}
            type={type}
            name={name}
            value={valueInput}
            onFocus={() => setIsFocused(true)}
            onBlur={() => {
              setIsFocused(false);
            }}
            onChange={onChange}
            placeholder={placeholder}
            maxLength={maxLength}
            minLength={minLength}
          />
        )}
        <span
          className={` text-left text-[#EE443F] text-[12px] pl-4 w-full  h-[20px]`}
        >
          {" "}
          {valueInput !== ""
            ? length < minLength || length > maxLength
              ? `The ${label} must contain between ${minLength} and ${maxLength} characters`
              : isFocused &&
                valueInput.length === maxLength &&
                `The field must not exceed ${maxLength} characters`
            : ""}{" "}
        </span>
      </div>
    </div>
  );
};

export default ComponentInput;
